import CustomLists from "@/components/elements/CustomLists/CustomLists"
import ListWithDescription from "@/components/elements/CustomLists/ListWithDescription"
import ImageWithContentLeft from "@/components/elements/ImageWithContent/ImageWithContentLeft"
import ImageWithContentRight from "@/components/elements/ImageWithContent/ImageWithContentRight"
import Paragraph from "@/components/elements/Paragraph/Paragraph"
import TitleBar from "@/components/elements/TitleBar/TitleBar"
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent"

const BituminousWaterproofingMembrane = () => {
    return (
        <>
            <TitleBar
                title="Bituminous Waterproofing Membrane"
                linkTitle="Services"
                linkTo="/services"
            />
            <ImageWithContentLeft
                imageUrl='/images/dummy-img.jpg'
                title="Description"
                content=" Bituminous coating is a popular waterproofing method that
                involves the application of a bitumen-based substance to surfaces for protection against water
                intrusion. Bitumen, a viscous and waterproof material derived from crude oil, serves as the primary
                component in these coatings. Bituminous coatings are widely used in various construction applications to
                provide effective waterproofing. Here's an overview of bituminous coating waterproofing:"
            />
            <TitleWithContent
                title="Key feature of Bituminous Coating Waterproofing">
                <ListWithDescription
                    items={[
                        {
                            title: "Waterproofing Properties:",
                            content: ["Bituminous coatings create a durable and impermeable layer, preventing water from penetrating the underlying surfaces."]
                        },
                        {
                            title: "Adhesion:",
                            content: ["These coatings adhere well to a variety of substrates, including concrete, metal, and masonry, providing a secure bond."]
                        },
                        {
                            title: "Flexibility:",
                            content: ["Bituminous coatings often exhibit flexibility, allowing them to accommodate minor movements in the substrate without cracking."]
                        },
                        {
                            title: "Versatility:",
                            content: ["Bituminous coatings can be used on various surfaces, such as roofs, foundations, basements, and walls, making them versatile for different construction needs."]
                        }
                    ]}
                />

            </TitleWithContent>

            <TitleWithContent
                title="Why Bitument is Popular in Waterproofing Sector"
            >
                <Paragraph
                    content="First of all, bitumen has an economic process. Bitumen, which
                    remains after crude oil distillation process, is a by-product When primary products such as petrol, diesel,
                    high octane fuels and gasoline are refined, the bitumen is left behind.
                    <br> <br> Besides, bitumen is a versatility product. It shows viscoelastic and thermoplastic behaviors.
                    Bitumen has both viscous and elastic behaviors depending on the temperature and loading time. At high-
                    temperature or in long loading times, bitumen behaves as a viscous material. At low temperatures or in fast
                    loading mode bitumen behaves like an elastic solid.
                    <br> <br> The melting point of the bitumen is not so high that it can be melted easily during the
                    application. The bitumen has a highly adhesive nature, which keeps the materials together strongly. All
                    these features prove that bitumen waterproofing is one of the most convenient solutions up to usage areas."
                />
            </TitleWithContent>

            <TitleWithContent title="Applications of Bituminous Waterproofing">

                <ListWithDescription
                    items={[
                        {
                            title: "Roof Waterproofing:",
                            content: ["Bituminous membranes are commonly used for waterproofing flat or sloping roofs, protecting them from rainwater and preventing leaks."]
                        },
                        {
                            title: "Foundation Waterproofing:",
                            content: ["Bituminous waterproofing helps create a protective barrier around building foundations, safeguarding against water seepage and damage."]
                        },
                        {
                            title: "Basement Waterproofing:",
                            content: ["Bituminous coatings or membranes are applied to basement walls and floors to prevent moisture infiltration and potential flooding."]
                        },
                        {
                            title: "Tunnel Waterproofing:",
                            content: ["Tunnels, whether for roads, railways, or underground utilities, can benefit from bituminous waterproofing to prevent water ingress and ensure structural integrity."]
                        }
                    ]}
                />

            </TitleWithContent>

            <TitleWithContent
                title="Advantages"
            >
                <CustomLists
                    items={[
                        [
                            'Excellent quality plugging compound-consistent performance.',
                            'High early strength —plugging is completed within 5 minutes',
                            'Simple Application', 'Excellent adhesion'
                        ],
                        [
                            'Water repellent concrete',
                            'Prevents/reduce sweating, efflorescence saltpetre action',
                            'Arrest shrinkage, better finish',
                            'Very economical, required at very lesser dosage'
                        ]
                    ]}
                />
            </TitleWithContent>

            <TitleWithContent title="Different Forms of Using Bitumen in Waterproofing">
                <Paragraph content="Various forms of bitumen used for waterproofing include:" />

            </TitleWithContent>
            <ImageWithContentLeft imageUrl="/images/dummy-img.jpg"
                title="Bituminous Paint"
                content="Bituminous paints consist of a mixture of bitumen with an organic solvent. Adding polymer to them leads to their stability and better performance in waterproofing. They are generally applied to the surface by spray, roller, or brush. Bituminous paints usually do not need to be preheated to use and are very stable. It can apply above and below wet surfaces. It can be used to waterproof concrete, metal, and wood structures, such as buildings, iron pipes, wooden boats, and so on."
            />


            <ImageWithContentRight imageUrl="/images/dummy-img.jpg"
                title="Bituminous Membrane"
                content="The bituminous membrane is generally used for sealing low-slope roofs. These types of roofs collect rainwater, which penetrates into the structure and damages the building. These membranes generally have additives. In the production process, they have been applied to glass wool rolls to prevent cracking during the winter.
                To stick them on the surfaces, the bituminous rolls are heated by a torch."
            />

            <ImageWithContentLeft imageUrl="/images/dummy-img.jpg"
                title="Bituminous Coating"
                content="The bituminous coating is mainly made up of bitumen that contains polymers and other additives to improve its waterproof properties.
                    The bituminous coating needs to be preheated. It is used for sealing concrete, building bases, swimming pools, and similar cases where the upper layer is water."
            />


            <TitleWithContent title=" Steps for Bituminous Protective coating waterproofing ">
                <Paragraph content="Steps for Bituminous Protective coating waterproofing" />
                <CustomLists
                    items={[
                        [
                            'Surface I substrate preparation is the most important for Bituminous Protective coating before application.',
                            'The concrete surface I substrate shall be clean and free from contamination such as dust. oil, grease, organic growth and release agents etc',
                            'All loosely adhering particles such as rust, mortar and cement laitance shall be removed.'
                        ],
                        [
                            'The surface would be cleaned by wire or stiff brushing and finally soft brushing or compressed air.',
                            'Cracks greater than 1.6mm wide shall be rout out.',
                            'The substrate condition shall be approved by the client prior to start application.',
                        ]
                    ]}
                />
            </TitleWithContent>

            <TitleWithContent title="Area of Application">
                <CustomLists
                    items={[
                        [
                            "Two coats of Bituminous Protective Coating shall be done under competent personnel's supervision and as per manufacturer's recommendations",
                            "The material w ill be stirred thoroughly to mix any solid materials that may have settled at the bottom of the packing, until a homogeneous consistency is achieved.",
                            "After thorough mixing,first coat of Corruprufe BRE shall be applied with brushes or rollers in a continuous uniform coating.",
                            "At least 4 hours drying time shall be allowed between the coats.",
                            "Second coat shall be applied in the same manner."
                        ],
                        [
                            "The theoretical coverage rate is 1.5 to 2 sq-m per liter, to give an approximate dry film thickness of 200 - 300 microns, as per manufacturer's recommendations",
                            "Adequate ventilation shall be provided (if required)",
                            "Application of water proofing system shall be done by experienced and competent personnel.",
                            "Unauthorized entry shall be restricted to the waterproofing areas.",
                            "Prior to concealing of the waterproofing inspection shall be raised for consultant approval. All subsequent works shall be carried out only after getting wr itten approval."
                        ]
                    ]}
                />
            </TitleWithContent>



            {/* Remove start */}





            {/* Remove end */}





        </>


    )
}

export default BituminousWaterproofingMembrane